import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { relayHub } from "@timibot/core";
import { App } from "./App";
import { AppContext } from "./context";
import { AppModel } from "./state/app";
import { registerServiceWorker } from "./pwa";
import "./styles.css";

const app = new AppModel();
// 调试用：在浏览器控制台里看状态（开发版还能拿到隧道，模拟断线）
(window as unknown as { timibot: AppModel }).timibot = app;
if (import.meta.env.DEV) (window as unknown as { timibotRelay: typeof relayHub }).timibotRelay = relayHub;

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AppContext.Provider value={app}>
      <App />
    </AppContext.Provider>
  </StrictMode>,
);

registerServiceWorker(app);
